export async function registerServiceWorker() {
  if (typeof window === "undefined") return;

  if ("serviceWorker" in navigator) {
    try {
      return await navigator.serviceWorker.register("/sw.js");
    } catch (err) {
      console.error("SW registration failed", err);
    }
  }
}
